import React from 'react';
import * as indexConteneurInfo from '../../ressources/glossaires/glossaire_conteneur_info';

import { checkMot } from '../../ressources/functionJS/checkMot';
import S from './ConteneurInformation.module.scss';

const ConteneurInformation = (props) => {
  switch (props.selectionInfo) {
    case indexConteneurInfo.profil:
      return <div className={S.ConteneurInfo}>{props.profil}</div>;
    case indexConteneurInfo.profilFunction:
      return <div className={S.ConteneurInfo}>{props.profilFunction}</div>;
    case indexConteneurInfo.ajouterForm:
      return <div className={S.ConteneurInfo}>{props.ajouterForm}</div>;
    case indexConteneurInfo.importation:
      return <div className={S.ConteneurInfo}>{props.importation}</div>;
    default:
      return (
        <span className={S.stile}>{checkMot('selectionne_sur_une_ligne')}</span>
      );
  }
};

export default ConteneurInformation;
